<template>
    <div class="call-task-count">
        <el-divider content-position="left">外部资源外呼</el-divider>
        <el-collapse v-model="activeNames" @change="handleChange_col"
            style="box-shadow: 0 15px 30px rgba(0, 0, 0, .3);border-radius: 10%;margin-top: 0.2rem;">
            <el-collapse-item title="一致性 Consistency" :name="v" v-for="(itemAll, v, index) in tableData" :key="index">
                <template slot="title">
                    <span class="col-title">{{ v }}</span>
                </template>
                <hr>
                <div class="el-card-con">
                    <el-tooltip effect="dark" content="点击进入列表" placement="top" v-for="(item, ind) in itemAll"
                        :key="ind">
                        <el-card
                            @click.native="$router.push({ name: 'CallTask', params: { cate: item.cate_id, keyword: 'a', tword: '总数', other: JSON.stringify({ first_level: v, second_level: item.call_cate.name }) } })"
                            shadow="always" class="box-card-my">
                            <div slot="header" class="clearfix">
                                <span class="box-card-title">
                                    {{ item.call_cate.name }}
                                    <el-tooltip effect="dark" :content="item.call_cate.desc" placement="top"
                                        v-if="item.call_cate.desc">
                                        <i style="font-size: small;" class="el-icon-info"></i>
                                    </el-tooltip>
                                </span>
                                <!-- <el-button style="float: right; padding: 3px 0" type="text"
                                @click="openDistributeDialog(item.call_cate.id)">分配资源</el-button> -->
                                <el-button style="float: right; padding: 3px 0" type="text"
                                    @click.stop="openSendSMSDialog(item.call_cate.id)">发送短信</el-button>
                            </div>
                            <table class="field-table" border>
                                <tr>
                                    <td>
                                        <span class="first-td">完成情况:</span>
                                    </td>
                                    <td>
                                        <el-tooltip effect="dark" content="点击进入相应列表" placement="top">
                                            <el-tag
                                                @click.stop="$router.push({ name: 'CallTask', params: { cate: item.cate_id, keyword: 'a', tword: '总数', other: JSON.stringify({ first_level: v, second_level: item.call_cate.name }) } })"
                                                class="table-dis" size="mini" type="primary" effect="dark">
                                                <span>
                                                    总数
                                                </span>
                                                <span>
                                                    {{ item.dis }}
                                                </span>
                                            </el-tag>
                                        </el-tooltip>
                                    </td>
                                    <td>
                                        <el-tooltip effect="dark" content="点击进入相应列表" placement="top">
                                            <el-tag
                                                @click.stop="$router.push({ name: 'CallTask', params: { cate: item.cate_id, keyword: 'effect', tword: '有效沟通', other: JSON.stringify({ first_level: v, second_level: item.call_cate.name }) } })"
                                                class="table-dis" size="mini" type="success" effect="dark">
                                                <span>
                                                    有效沟通
                                                </span>
                                                <span>
                                                    {{ item.effect }}
                                                </span>
                                            </el-tag>
                                        </el-tooltip>
                                    </td>
                                    <td>
                                        <el-tooltip effect="dark" content="点击进入相应列表" placement="top">
                                            <el-tag
                                                @click.stop="$router.push({ name: 'CallTask', params: { cate: item.cate_id, keyword: 'not_effect', tword: '无效沟通', other: JSON.stringify({ first_level: v, second_level: item.call_cate.name }) } })"
                                                class="table-dis" size="mini" type="warning" effect="dark">
                                                <span>
                                                    无效沟通
                                                </span>
                                                <span>
                                                    {{ item.not_effect }}
                                                </span>
                                            </el-tag>
                                        </el-tooltip>
                                    </td>
                                    <td>
                                        <el-tooltip effect="dark" content="点击进入相应列表" placement="top">
                                            <el-tag
                                                @click.stop="$router.push({ name: 'CallTask', params: { cate: item.cate_id, keyword: 'not_con', tword: '未联系', other: JSON.stringify({ first_level: v, second_level: item.call_cate.name }) } })"
                                                class="table-dis" size="mini" type="danger" effect="dark">
                                                <span>
                                                    未联系
                                                </span>
                                                <span>
                                                    {{ item.dis - (item.effect + item.not_effect) }}
                                                </span>
                                            </el-tag>
                                        </el-tooltip>
                                    </td>
                                    <td>
                                        <el-tag @click.stop="" class="table-dis table-pers" size="mini" type="success"
                                            effect="dark">
                                            <span>
                                                完成率
                                            </span>
                                            <span>
                                                {{ (((item.effect + item.not_effect) / item.dis) * 100).toFixed(2) }}%
                                            </span>
                                        </el-tag>
                                        <i v-if="(((item.effect + item.not_effect) / item.dis) * 100).toFixed(2) == 100.00"
                                            class="el-icon-circle-check" style="color: #67C23A;"></i>
                                    </td>
                                </tr>
                            </table>
                            <!-- <div class="btn-con">
                            <el-button type="warning" size="mini" round
                                @click="openDisLogDrawer(item.call_cate.id)">分配记录</el-button>
                        </div> -->
                        </el-card>
                    </el-tooltip>
                </div>
            </el-collapse-item>
        </el-collapse>

        <el-dialog :visible.sync="dialog_sms" @closeDialog="closeDialog" @beforeCloseDialog="beforeCloseDialog"
            width="40%" center>
            <template v-slot:title>
                <span class="dia-title">
                    发送短信
                </span>
            </template>
            <div class="cal-tas-m-bg-con">
                <send-s-m-s :cate="smsId" />
            </div>
        </el-dialog>
    </div>
</template>

<script>
import SendSMS from './Components/SendSMS'
export default {
    name: 'CallTaskCount',
    components: { SendSMS },
    data() {
        return {
            hyperfHost:
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:9501/v1/"
                    : "https://qyh-next-server.zhang66.cn/v1/",
            tableData: [],
            activeNames: [],
            smsId: '',
            dialog_sms: false
        }
    },
    methods: {
        loadTable() {
            this.$axios.get(`${this.hyperfHost}api/call_task_count/list`, {
                loadingClose: true,
                params: {
                    // search: this.search,
                }
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.tableData = data.data
                    this.activeNames = data.col_name
                }
            }).catch()
        },
        handleChange_col(val) {

        },
        openSendSMSDialog(id) {
            this.smsId = id
            this.dialog_sms = true
        },
        closeDialog() {
            this.smsId = ''
        },
        beforeCloseDialog() {

        },
    },
    mounted() {
        this.loadTable()
    }
}
</script>

<style scoped>
.call-task-count {
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.call-task-count .col-title {
    font-size: large;
    font-weight: bold;
    margin-left: 0.2rem;
    color: #409EFF;
}

.call-task-count .box-card-my {
    /* width: 9rem;
    height: fit-content; */
    flex: 1;
    flex-basis: 49%;
    box-sizing: border-box;
    cursor: pointer;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.call-task-count .clearfix:after {
    clear: both
}

.call-task-count .box-card-title {
    font-size: large;
    font-weight: bold;
}

/* 表格 */
.call-task-count .field-table {
    border-color: #eeeaea;
}

.call-task-count .centered {
    /* 水平居中 */
    text-align: center;
    /* 垂直居中 */
    vertical-align: middle;
}

.call-task-count .field-table td {
    padding: 0.1rem 0.15rem;
    box-sizing: border-box;
}

.call-task-count .centered-count {
    text-align: right;
}

/* 表格end */
.call-task-count .table-dis {
    /* cursor: pointer; */
    font-size: small;
}

.call-task-count .first-td {
    white-space: nowrap;
}

.call-task-count .col-title {
    font-size: large;
    font-weight: bold;
    margin-left: 0.2rem;
    color: #409EFF;
}

.call-task-count .el-card-con {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 0.2rem;
    box-sizing: border-box;
    gap: 0.2rem;
    align-items: stretch;
}

.call-task-count .btn-con {
    display: flex;
    justify-content: space-between;
    padding-top: 0.2rem;
}

.call-task-count .table-pers {
    cursor: default;
}

.call-task-count .dia-title {
    font-size: large;
    font-weight: bold;
    color: #409EFF;
}

.call-task-count>>>.el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /*height:600px;*/
    max-height: calc(100% - 200px);
    max-width: calc(100% - 30px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, .3);
}

.call-task-count>>>.el-dialog .el-dialog__body {
    flex: 1;
    overflow: auto;
}

.call-task-count .cal-tas-m-bg-con {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/cloudClue/CallTaskCount.vue